import React, { useState, useEffect } from 'react';
import AgentSidebarNav from './AgentSidebarNav';
import AgentHeaderTop from './AgentHeaderTop';
import '../../assets/css/agent-custom.css';

interface AgentLayoutProps {
    children: React.ReactNode;
}

const AgentLayout: React.FC<AgentLayoutProps> = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileShow, setMobileShow] = useState(false);

    // Close mobile sidebar on window resize
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                setMobileShow(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="agent-layout">
            <AgentSidebarNav
                collapsed={collapsed}
                mobileShow={mobileShow}
                setMobileShow={setMobileShow}
            />

            <main className={`agent-main ${collapsed ? 'expanded' : ''}`}>
                <AgentHeaderTop
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    mobileShow={mobileShow}
                    setMobileShow={setMobileShow}
                />

                <div className="agent-content">
                    {children}
                </div>
            </main>

            {/* Mobile Overlay */}
            {mobileShow && (
                <div
                    className="admin-overlay d-lg-none"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 999
                    }}
                    onClick={() => setMobileShow(false)}
                ></div>
            )}
        </div>
    );
};

export default AgentLayout;
